StpAccountsController.$inject = ['$scope', '$modalInstance', 'companyAccounts', '$timeout'];

export default function StpAccountsController($scope, $modalInstance, companyAccounts, $timeout) {
    $scope.accountSearchText = '';
    $scope.close = close;
    $scope.setForm = setForm;
    $scope.companyAccounts = companyAccounts;
    $scope.filteredAccounts = companyAccounts;
    $scope.selectAccount = selectAccount;

    $scope.$watch('accountSearchText', filterAccounts);

    // this will dismiss the window.
    function close() {
        $modalInstance.dismiss();
    }

    // used to set the form instance.
    function setForm(form) {
        $scope.form = form;
    }

    function selectAccount(account) {
        $modalInstance.close(account);
    }

    function filterAccounts(searchText) {
        if (!searchText) {
            $scope.filteredAccounts = $scope.companyAccounts;
            return;
        }
        const term = searchText.toLowerCase();
        $scope.filteredAccounts = $scope.companyAccounts.filter(
            account => isMatch(account.number, term) || isMatch(account.name, term)
        );
    }

    function isMatch(field, term) {
        return field ? field.toString().toLowerCase().indexOf(term) !== -1 : false;
    }
}
